<template>
  <DialogLayout
    title="詳細情報"
    :visible.sync="dialogVisible"
    width="65em"
    @open="open"
  >
    <template #form>
      <FeesForWeightAndNoiseForm
        ref="feesForWeightAndNoiseForm"
        v-model="feesForWeightAndNoiseFormModel"
        label-width="10em"
        formMode="edit"
        billingYmMode="search"
        :editDisabledMode="editDisabledMode"
        :autocomplete-customer-code-set="autocompleteCustomerCodeSet"
        :autocomplete-registration_symbol-set="autocompleteRegistrationSymbolSet"
        :autocomplete-airport-code-set="autocompleteAirportCodeSet"
        :autocomplete-model-code-set="autocompleteModelCodeSet"
      />
    </template>
    <template v-if='!editDisabledMode' #footer>
      <EditDialogFooter
        @update="clickUpdate"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import FeesForWeightAndNoiseForm from '@/components/organisms/dialog/calculation/FeesForWeightAndNoiseForm.vue'
import EditDialogFooter from '@/components/organisms/dialog/EditDialogFooter.vue'
// import FeesForWeightAndNoiseAutocompleteLoader from '@/mixins/FeesForWeightAndNoiseAutocompleteLoader.vue'

export default {
  components: {
    DialogLayout,
    FeesForWeightAndNoiseForm,
    EditDialogFooter
  },
  props: {
    autocompleteRegistrationSymbolSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteModelCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteCustomerCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteAirportCodeSet: {
      type: Array,
      default: () => ([])
    },
    currentRow: {
      type: Object,
      default: () => {
        return {}
      }
    },
    visible: Boolean
  },
  data () {
    return {
      feesForWeightAndNoiseFormModel: {
        registration_symbol: undefined,
        billing_ym: undefined,
        bill_to_code: undefined,
        route_code: undefined,
        callsign: undefined,
        departure_airport_code: undefined,
        destination_airport_code: undefined,
        model_code: undefined,
        landing_fee_without_tax: undefined,
        landing_fee_tax: undefined,
        landing_fee_with_tax: undefined,
        count: undefined,
        landingFeeBeforeExemption: undefined,
        landing_time: undefined,
        tax: undefined,
        flight_purpose_code: undefined,
        aircraft_type: undefined,
        weight: undefined,
        noise_level: undefined,
        exemption_code: undefined,
        exemption_rate: undefined,
        unit_fee: undefined,
        taxation: undefined,
        regist_type: undefined,
        billing_exclusion_flag: undefined,
        updated_on: undefined
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (visible) {
        this.$emit('update:visible', visible)
      }
    },
    editDisabledMode: {
      get () {
        return this.feesForWeightAndNoiseFormModel.regist_type === '1' || parseInt(this.feesForWeightAndNoiseFormModel.billing_ym) < parseInt(this.getDefaultBillingYm())
      }
    }
  },
  mounted () {
  },
  methods: {
    async clickUpdate () {
      this.$loadingMask.on()
      this.$refs.feesForWeightAndNoiseForm.validate()
        .then((valid) => {
          return this.$axios.put('/fees-for-weight-and-noise', this.feesForWeightAndNoiseFormModel)
        })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.dialogVisible = false
          this.$emit('refresh', this.feesForWeightAndNoiseFormModel.billing_ym)
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message)
                break
              default:
            }
          }
          this.$loadingMask.off()
        })
    },
    open () {
      const trimItem = ['bill_to_code', 'route_code']
      this.$nextTick(() => {
        this.$refs.feesForWeightAndNoiseForm.clearFields()
        Object.keys(this.feesForWeightAndNoiseFormModel)
          .forEach((x) => {
            if (trimItem.includes(x)) {
              this.currentRow[x] = this.currentRow[x].trimEnd()
            }
            this.$set(this.feesForWeightAndNoiseFormModel, x, this.currentRow[x])
          })
      })
    }
  }
}
</script>

<style lang="scss">
</style>
